import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import {
  Modal,
  ButtonContainer,
  ButtonSecondary,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { ModalContent, ModalStatus } from './components';

import { requestHomeBrokerAccess } from '@/modules/trade/services/home-broker';
import { TradeHomeBrokerStatus } from '@/modules/trade/services/account';
import {
  trackRequestHomeBrokerClick,
  trackCancelHomeBrokerClick
} from '@/modules/trade/views/TradeView/trackers';

enum BrokerSteps {
  request = 1,
  status = 2
}

interface Emits {
  (event: 'close'): void;
  (event: 'update-status'): void;
}

interface Props {
  isOpen: boolean;
  brokerStatus: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestBrokerModal',
  props: {
    isOpen: { type: Boolean },
    brokerStatus: null
  },
  emits: ["close", "update-status"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'close'): void;
  (event: 'update-status'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  brokerStatus: string;
};





const isLoading = ref(false);
const step = ref(BrokerSteps.request);

const title = computed(() => {
  return props.brokerStatus === TradeHomeBrokerStatus.Requested
    ? 'Home Broker Solicitado'
    : 'Solicitar Home Broker';
});

const isHomeBrokerDisabled = computed(() => {
  return (
    step.value === BrokerSteps.request &&
    props.brokerStatus === TradeHomeBrokerStatus.Disabled
  );
});

const isBrokerStatusRequested = computed(() => {
  return props.brokerStatus === TradeHomeBrokerStatus.Requested;
});

const modalStatusProps = computed(() => {
  const infoProps = {
    status: 'information',
    title: 'Quase lá! Estamos preparando o Home Broker para você',
    description: 'Aguarde alguns minutos para começar a investir.'
  };
  const successProps = {
    status: 'positive',
    title: 'O Home Broker foi solicitado',
    description: 'Aguarde alguns minutos para começar a investir.'
  };

  return isBrokerStatusRequested.value ? infoProps : successProps;
});

function emitClose() {
  emits('close');
}

function emitUpdateStatus() {
  emits('update-status');
}

function handleCancelClick() {
  trackCancelHomeBrokerClick();
  emitClose();
}

function closeBrokerModal() {
  if (isBrokerStatusRequested.value) emitClose();
  else emitUpdateStatus();
}

async function requestBroker() {
  trackRequestHomeBrokerClick();
  isLoading.value = true;

  try {
    await requestHomeBrokerAccess();
  } finally {
    isLoading.value = false;
    step.value = BrokerSteps.status;
  }
}

return { __sfc: true,BrokerSteps, emits, props, isLoading, step, title, isHomeBrokerDisabled, isBrokerStatusRequested, modalStatusProps, emitClose, emitUpdateStatus, handleCancelClick, closeBrokerModal, requestBroker, Modal, ButtonContainer, ButtonSecondary, LoaderIndicator, ModalContent, ModalStatus }
}

})